/**
 * The two states (user, 2026-10-11): in combat and out of combat. Every real fight (a hit given or taken, an attacking skill
 * used) calls enterCombat, which sets Entity.combatT to COMBAT_STATE.linger; it counts down in World.step. Out of combat = combatT <= 0.
 * While in combat: no sitting (meditate), mounting, entering buildings, carriage, group dance, crafting, neigong switch, PK off,
 * guide travel, arena sign-up. Heals and buffs do not enter combat. NPC staging (folk spar, story beats) sets its own short
 * values on purpose (they are not fights) and is not routed through here.
 */
export const COMBAT_STATE = { linger: 10 } as const;

interface CombatBody {
  combatT: number;
}

/** A fight touched this entity: (re)start the linger. Never shortens a longer timer. */
export function enterCombat(e: CombatBody): void {
  if (e.combatT < COMBAT_STATE.linger) e.combatT = COMBAT_STATE.linger;
}

export function inCombat(e: CombatBody): boolean {
  return e.combatT > 0;
}

/** Whole seconds left in combat (rounded up, at least 1 while in combat, 0 when out). */
export function combatSecondsLeft(e: CombatBody): number {
  return e.combatT > 0 ? Math.max(1, Math.ceil(e.combatT)) : 0;
}

/** The blocked-action notice, with the seconds left: "ยังอยู่ในการต่อสู้ (อีก 7 วินาที)". Pass what is blocked as `what` to append it. */
export function combatBlockText(e: CombatBody, what?: string): string {
  const base = `ยังอยู่ในการต่อสู้ (อีก ${combatSecondsLeft(e)} วินาที)`;
  return what ? `${base} ${what}` : base;
}
